import { combineReducers } from 'redux'
import { attendanceReducer } from './attendance.reducer';
import { authReducer } from './auth.reducer'
import { campusReducer } from './campus.reducer';
import { feeReducer } from './fee.reducer';
import { gradeReducer } from './grade.reducer';
import { payrollReducer } from './payroll.reducer';
import { roleReducer } from './role.reducer';
import { sectionReducer } from './section.reducer';
import { sessionReducer } from './session.reducer';
import { studentReducer } from './student.reducer';
import { userReducer } from './user.reducer';

export default combineReducers({
    auth: authReducer,
    roles: roleReducer,
    users: userReducer,
    campuses: campusReducer,
    sections: sectionReducer,
    grades: gradeReducer,
    sessions: sessionReducer,
    students: studentReducer,
    fees: feeReducer,
    attendance: attendanceReducer,
    payroll: payrollReducer
});
